import React from 'react';

//https://reactjs.org/docs/lists-and-keys.html#extracting-components-with-keys
class TestimonialItem extends React.Component {
	
	constructor() {
		super();
	}
	
	//https://reactjs.org/docs/dom-elements.html#dangerouslysetinnerhtml
	quote() {
        let quote = this.props.quote;
        return { __html: quote };			
	}

	render() {


		return (
			<li className="testimonial__item">		
				<blockquote>		
					<figure className="ico">
						<img loading="lazy" src={`${wp_core.theme_url}/assets/img/ico/quote.svg`} />						
					</figure>
					<q className="testimonial__quote" dangerouslySetInnerHTML={this.quote()} />
				</blockquote>
				<div className="testimonial__author">
					<figure className="testimonial__avatar">
						{this.props.avatar ? (
							<img loading="lazy" src={this.props.avatar} alt={this.props.title} />
						) : (
							<img loading="lazy" src={`${wp_core.theme_url}/assets/img/avatar-default.png`} alt={this.props.title} />
						)}						
					</figure>
					<div className="testimonial__title">
						<h4>{this.props.title}</h4>
						<span>{this.props.desc}</span>					
					</div>

				</div>

			</li>
		);
	}
}

export default TestimonialItem;